export default {"src":"/_next/static/image/public/images/ic_read_radiology.24d007f2dcba1bf017fa395f9774f3f8.svg","height":36,"width":36};